import React from 'react';
import useStyles from '@front10/helpers/dist/UseStyles';
import Col from '../../../elements/Col';
import Row from '../../../elements/Row';
import Box from '../../../elements/Box';

const styles = {
  header: {
    main: {
      padding: '1.4rem'
    },
    headerTitle: {
      height: '40px',
      marginBottom: '0.5rem'
    },
    headerSubtitle: {
      height: '20px'
    }
  },
  sorting: {
    height: '40px',
    marginTop: '1.5rem',
    float: 'right'
  },
  list: {
    marginTop: '1.5rem'
  },
  fareItem: {
    main: {
      marginBottom: '0.5rem'
    },
    box: {
      padding: '1.5rem'
    },
    title: {
      height: '30px',
      marginBottom: '1rem'
    },
    subtitle: {
      height: '20px'
    },
    button: {
      height: '30px',
      float: 'right'
    }
  },
  loadMore: {
    main: {
      display: 'flex',
      justifyContent: 'center'
    },
    box: {
      width: '200px',
      height: '40px',
      marginTop: '1rem'
    }
  }
};

const SkeletonMultipleTravelClasses = (props) => {
  const { header, sorting, list, fareItem, loadMore } = styles;
  const [className, style] = useStyles(props);
  return (
    <Box
      className={`${className} fr-skeleton`}
      style={style}
      dataTestId="skeletonFareListTwoColumns"
    >
      <Row gutters>
        <Col>
          <Box className="fr-skeleton-box" style={header.main}>
            <Col xs="8" className="fr-skeleton-element" style={header.headerTitle} />
            <Col xs="10" className="fr-skeleton-element" style={header.headerSubtitle} />
          </Box>
        </Col>
      </Row>
      <Row gutters>
        <Col>
          <Col xs="3" className="fr-skeleton-element" style={sorting} />
        </Col>
      </Row>
      <Row gutters style={list}>
        {Array.from({ length: 4 }, (_, index) => (
          <Col xs="12" key={index} style={fareItem.main}>
            <Box className="fr-skeleton-box fr-clearfix" style={fareItem.box}>
              <Col xs="6" className="fr-skeleton-element" style={fareItem.title} />
              <Col xs="7" className="fr-skeleton-element" style={fareItem.subtitle} />
              <Col xs="4" className="fr-skeleton-element" style={fareItem.button} />
            </Box>
          </Col>
        ))}{' '}
      </Row>
      <Row gutters style={loadMore.main}>
        <Box style={loadMore.box} className="fr-skeleton-element" />
      </Row>
    </Box>
  );
};

SkeletonMultipleTravelClasses.componentName = 'SkeletonMultipleTravelClasses';

export default SkeletonMultipleTravelClasses;
